export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_40690e67-471a-43b7-a46e-74f602ac6ff0/artifacts/2yhk1a9y_lomedix.Tech%20dp.jpeg";

export const COMPANY = {
  name: "ClomedixTech",
  tagline: "Digital Software Service Solutions",
  email: "info@clomedixtech.com",
  whatsappNumber: "+91 7010548247",
  whatsappUrl: "https://wa.me/917010548247",
  phoneRaw: "+917010548247",
  socials: {
    facebook: "https://facebook.com/Clomedix.Tech",
    instagram: "https://www.instagram.com/clomedixtech/",
    youtube: "https://www.youtube.com/@ClomedixTech",
    whatsapp: "https://wa.me/917010548247",
  },
};

export const openWhatsApp = (e) => {
  if (e) e.preventDefault();
  window.open("https://wa.me/917010548247", "_blank", "noopener,noreferrer");
};

export const SERVICE_OPTIONS = [
  "Website Design & Development",
  "Software / CRM / ERP",
  "Mobile App Development",
  "Cloud Solutions",
  "AI Automation",
  "Data Analytics",
  "Digital Marketing / SEO",
  "Social Media Management",
  "Graphic Design & Branding",
  "Video & Animation",
  "Other",
];

export const STATS = [
  { value: "100+", label: "Happy Clients" },
  { value: "250+", label: "Projects Delivered" },
  { value: "99%", label: "Client Satisfaction" },
  { value: "24/7", label: "Support" },
];

export const TRUST_BADGES = [
  "Trusted IT Partner",
  "AI Powered Solutions",
  "Fast Delivery",
  "Business Growth Focused",
];

export const SERVICE_CATEGORIES = [
  {
    id: "dev",
    title: "Development & Tech",
    icon: "Code2",
    color: "from-blue-500 to-indigo-600",
    tagline: "Websites, software, mobile apps & maintenance.",
    image: "/images/services/dev.jpg",
    alt: "Developer working on code for a ClomedixTech client website.",
    items: [
      "Website Design", "Landing Pages", "Business Websites", "Corporate Websites",
      "E-Commerce Websites", "Software Development", "CRM Development", "ERP Development",
      "Mobile Apps", "Google Business Profile", "Website Maintenance", "Hosting & Domains",
    ],
  },
  {
    id: "cloud",
    title: "Cloud Services",
    icon: "Cloud",
    color: "from-sky-500 to-blue-600",
    tagline: "Migration, infrastructure, Azure & backups.",
    image: "/images/services/cloud.jpg",
    alt: "Cloud infrastructure and server room representing ClomedixTech cloud services.",
    items: [
      "Azure AI Foundry / Azure OpenAI",
      "Azure Cosmos DB & Azure SQL Database",
      "Microsoft Entra ID (SSO & Access)",
      "Azure Key Vault (Secrets Management)",
      "Cloud Migration", "Cloud Infrastructure",
      "Cloud Storage", "Cloud Security", "Cloud Backup",
      "Cloud Monitoring", "Cloud Consulting",
    ],
  },
  {
    id: "ai",
    title: "AI Services",
    icon: "Sparkles",
    color: "from-violet-500 to-purple-600",
    tagline: "AI concierge, RAG, agents & automation.",
    image: "/images/services/ai.jpg",
    alt: "Abstract AI neural network visual representing ClomedixTech AI services.",
    items: [
      "24×7 AI Concierge Chatbot Deployment",
      "AI Meeting Scheduler (calendar + reminders)",
      "AI Document Intelligence & Data Extraction",
      "RAG / AI Knowledge Base Setup",
      "Multi-Agent AI Advisory Frameworks",
      "AI Automation & Workflow",
      "AI Content Writing", "AI Image Generation",
      "AI Video Generation", "AI Voiceover",
      "AI Business Solutions",
    ],
  },
  {
    id: "data",
    title: "Data Analytics",
    icon: "BarChart3",
    color: "from-purple-500 to-pink-600",
    tagline: "BI, dashboards & predictive analytics.",
    image: "/images/services/data.jpg",
    alt: "Business intelligence dashboard visualisation representing ClomedixTech data analytics.",
    items: [
      "Business Intelligence", "Dashboards", "Reporting", "Power BI",
      "Google Analytics", "Data Visualization", "Performance Tracking", "Predictive Analytics",
    ],
  },
  {
    id: "social",
    title: "Social Media",
    icon: "Share2",
    color: "from-pink-500 to-rose-600",
    tagline: "Content, growth & community management.",
    image: "/images/services/social.jpg",
    alt: "Smartphone showing social media feeds — ClomedixTech social media management.",
    items: [
      "Social Media Management", "Instagram Marketing", "Facebook Marketing",
      "LinkedIn Marketing", "Content Creation", "Brand Building", "Community Management",
    ],
  },
  {
    id: "marketing",
    title: "Digital Marketing",
    icon: "Megaphone",
    color: "from-fuchsia-500 to-pink-600",
    tagline: "Ads, SEO, email & lead generation.",
    image: "/images/services/marketing.jpg",
    alt: "Digital marketing performance analytics — ClomedixTech Google & Meta Ads.",
    items: [
      "Google Ads", "Facebook Ads", "Instagram Ads", "SEO",
      "Local SEO", "Email Marketing", "Lead Generation", "Marketing Automation",
    ],
  },
  {
    id: "design",
    title: "Graphic Design",
    icon: "Palette",
    color: "from-indigo-500 to-violet-600",
    tagline: "Logos, brand identity & print collateral.",
    image: "/images/services/design.jpg",
    alt: "Brand identity and logo design assets by ClomedixTech.",
    items: [
      "Logo Design", "Poster Design", "Flyers", "Brochures",
      "Business Cards", "Packaging", "Social Media Creatives", "Brand Identity",
    ],
  },
  {
    id: "video",
    title: "Video & Animation",
    icon: "Video",
    color: "from-rose-500 to-pink-600",
    tagline: "Reels, motion graphics & 3D animation.",
    image: "/images/services/video.jpg",
    alt: "Cinema camera and film production — ClomedixTech video editing and animation.",
    items: [
      "Video Editing", "Reels", "Shorts", "Motion Graphics",
      "Explainer Videos", "3D Animation", "Pixar Style", "Corporate Videos",
    ],
  },
  {
    id: "security",
    title: "Enterprise & Security",
    icon: "ShieldCheck",
    color: "from-slate-700 to-indigo-700",
    tagline: "Cybersecurity, GRC, compliance & continuity.",
    image: "/images/services/security.jpg",
    alt: "Digital padlock representing ClomedixTech cybersecurity and compliance services.",
    items: [
      "Cybersecurity Advisory & Threat Protection",
      "Security Posture Assessment",
      "GRC (Governance, Risk & Compliance) Consulting",
      "Regulatory & Industry Compliance Advisory",
      "Business Continuity Planning",
      "Data Protection & Backup Strategy",
    ],
  },
];

export const WHY_CHOOSE_US = [
  { icon: "Users", title: "Expert Team", desc: "Seasoned engineers, designers and strategists." },
  { icon: "Sparkles", title: "AI Powered", desc: "Modern AI woven into every workflow." },
  { icon: "Tag", title: "Affordable Pricing", desc: "Enterprise quality without enterprise cost." },
  { icon: "Award", title: "Enterprise Quality", desc: "Best practices, tested & production ready." },
  { icon: "Headphones", title: "24×7 Support", desc: "Real humans, always a message away." },
  { icon: "Zap", title: "Fast Delivery", desc: "Ship fast without cutting corners." },
  { icon: "ShieldCheck", title: "Secure Solutions", desc: "Security & compliance by default." },
  { icon: "TrendingUp", title: "Growth Focused", desc: "Outcomes over outputs — always." },
];

export const INDUSTRIES = [
  { name: "Healthcare", icon: "HeartPulse" },
  { name: "Education", icon: "GraduationCap" },
  { name: "Finance", icon: "Landmark" },
  { name: "Retail", icon: "ShoppingBag" },
  { name: "Manufacturing", icon: "Factory" },
  { name: "Startups", icon: "Rocket" },
  { name: "Real Estate", icon: "Building2" },
  { name: "Hospitality", icon: "Hotel" },
  { name: "IT & SaaS", icon: "Server" },
  { name: "E-commerce", icon: "ShoppingCart" },
];

export const PORTFOLIO = [
  { title: "Enterprise CRM Platform", category: "Software", tags: ["React", "Node.js", "MongoDB"], image: "/images/portfolio/crm-platform.jpg", alt: "Enterprise CRM dashboard designed and built by ClomedixTech showing sales pipeline and analytics." },
  { title: "Cloud Migration — Retail Chain", category: "Cloud", tags: ["AWS", "Docker"], image: "/images/portfolio/cloud-migration.jpg", alt: "AWS cloud infrastructure migration project for a retail chain by ClomedixTech." },
  { title: "AI Chatbot for Healthcare", category: "AI", tags: ["OpenAI", "Python"], image: "/images/portfolio/ai-chatbot.jpg", alt: "AI healthcare chatbot interface designed by ClomedixTech." },
  { title: "E-commerce Rebrand & Site", category: "Website", tags: ["Next.js", "Shopify"], image: "/images/portfolio/ecommerce.jpg", alt: "Modern e-commerce website rebrand delivered by ClomedixTech." },
  { title: "BI Dashboard Suite", category: "Analytics", tags: ["Power BI", "SQL"], image: "/images/portfolio/bi-dashboard.jpg", alt: "Business intelligence dashboard suite with Power BI visualisations by ClomedixTech." },
  { title: "Fitness Mobile App", category: "Mobile", tags: ["Flutter", "Firebase"], image: "/images/portfolio/fitness-app.jpg", alt: "Flutter fitness mobile app built by ClomedixTech." },
  { title: "Real Estate Marketing Campaign", category: "Marketing", tags: ["Meta Ads", "SEO"], image: "/images/portfolio/real-estate.jpg", alt: "Real estate digital marketing campaign designed by ClomedixTech." },
  { title: "Brand Identity — SaaS Startup", category: "Design", tags: ["Logo", "Brand"], image: "/images/portfolio/brand-identity.jpg", alt: "SaaS startup brand identity and logo system by ClomedixTech." },
  { title: "3D Product Launch Video", category: "Video", tags: ["Motion", "3D"], image: "/images/portfolio/video-3d.jpg", alt: "3D product launch video and motion graphics work by ClomedixTech." },
];

export const PORTFOLIO_FILTERS = ["All", "Software", "Cloud", "AI", "Website", "Analytics", "Mobile", "Marketing", "Design", "Video"];

export const TECHNOLOGIES = [
  "React", "Next.js", "Node.js", "Python", "Flutter", "AWS", "Azure",
  "Google Cloud", "Firebase", "MongoDB", "MySQL", "Docker", "OpenAI",
];

export const TESTIMONIALS = [];

export const FAQS = [
  {
    q: "What services does ClomedixTech offer?",
    a: "ClomedixTech is a remote-first digital software services company serving clients globally. We build websites and web apps, custom software, CRM/ERP systems and mobile apps, and we run digital marketing, social media management, Facebook & Google Ads, SEO, video editing, poster and brand design, and domain & hosting setup. We also deliver AI automation (chatbots, document intelligence, RAG knowledge bases), cloud solutions on AWS and Azure, and cybersecurity/GRC advisory for growing enterprises.",
  },
  {
    q: "How long does a typical project take?",
    a: "Landing pages ship in 5–7 working days, business and corporate websites in 2–3 weeks, and e-commerce sites in 3–5 weeks. Custom software, mobile apps, and enterprise integrations run in 4–12 week sprints with weekly demos so you always see progress. Digital marketing campaigns go live within 3–5 days of onboarding, with the first month focused on optimisation and testing.",
  },
  {
    q: "Do you work with startups and SMEs?",
    a: "Yes — over 70% of our clients are early-stage startups and small-to-medium businesses. We tailor lightweight engagements for founders (single landing page + ads, MVP builds) and scale up as you grow, without long-term lock-ins. If you're pre-revenue, we can also share flexible milestone payment plans.",
  },
  {
    q: "How is pricing structured?",
    a: "We offer three transparent engagement models: fixed-scope quotes for defined projects (a website, logo, video), milestone-based billing for larger builds paid across delivery stages, and monthly retainers for ongoing marketing, maintenance or AI operations. Every quote is tailored to scope after a free 15-minute discovery call — share your requirements and we'll return a specific proposal within 24 hours.",
  },
  {
    q: "Do you offer post-launch support?",
    a: "Yes. Every project ships with 30 days of complimentary bug-fix support. Beyond that we offer maintenance retainers with SLAs — response times as fast as 2 hours for critical issues — plus dedicated account managers, hosting monitoring, monthly performance reports, and content or ad-campaign updates as needed.",
  },
  {
    q: "Can you sign an NDA?",
    a: "Absolutely. We routinely sign one-way and mutual NDAs before sharing any project details, and we can also work under your existing MSA, SoW, or DPA agreements. Share your NDA over email at info@clomedixtech.com and we'll return it counter-signed within a business day.",
  },
];

export const FLOATING_ICONS = [
  { icon: "Cloud", label: "Cloud", x: "6%", y: "10%", delay: "0s" },
  { icon: "Bot", label: "AI", x: "88%", y: "12%", delay: "0.6s" },
  { icon: "BarChart3", label: "Analytics", x: "-2%", y: "48%", delay: "1.2s" },
  { icon: "ShieldCheck", label: "Security", x: "92%", y: "50%", delay: "0.3s" },
  { icon: "Globe", label: "Website", x: "10%", y: "82%", delay: "1.6s" },
  { icon: "Smartphone", label: "App", x: "82%", y: "82%", delay: "0.9s" },
  { icon: "Search", label: "SEO", x: "48%", y: "-4%", delay: "0.4s" },
  { icon: "Megaphone", label: "Marketing", x: "50%", y: "96%", delay: "1.1s" },
];
